'use strict';

exports.__esModule = true;
var UrlUpdateTypes = {
  replace: 'replace',
  replaceIn: 'replaceIn',
  push: 'push',
  pushIn: 'pushIn'
};

exports.default = UrlUpdateTypes;


//////////////////
// WEBPACK FOOTER
// ./~/react-url-query/lib/UrlUpdateTypes.js
// module id = 28
// module chunks = 0